export default async function loadScript(url) {
  const DOC = document.getElementsByTagName('head')[0];
  const js = document.createElement('script');
  js.setAttribute('type', 'text/javascript');
  js.setAttribute('src', url);
  DOC.appendChild(js);
  return new Promise(resolve => {
    if (document.all) {
      //如果是IE
      js.onreadystatechange = function() {
        if (js.readyState == 'loaded' || js.readyState == 'complete') {
          resolve();
        }
      };
    } else {
      js.onload = function() {
        resolve();
      };
    }
  });
}



// WEBPACK FOOTER //
// ./src/util/loadscript.js